.filterBox {
    background-color: white;
    padding: 16px;
    width: 205px;
    font-size: 14px;
}

.checkboxContainer {
    display: block;
    position: relative;
    padding-left: 22px;
    margin-bottom: 8px!important;
    line-height: 14px;
    cursor: pointer;
    user-select: none;
}

/* Hide the browser's default checkbox */
.checkboxContainer input {
    position: absolute;
    opacity: 0;
    cursor: pointer;
    height: 0;
    width: 0;
  }

.checkbox {
    position: absolute;
    top: 0;
    left: 0;
    height: 16px;
    width: 16px;
    border-radius: 4px;
    background-color: #eee;
}

.checkboxContainer:hover input~.checkbox {
    background-color: #ccc;
}

.checkboxContainer input:checked~.checkbox {
    background-color: #0BAEFF;
}

/* Create the checkbox/indicator (hidden when not checked) */
.checkbox:after {
    content: "";
    position: absolute;
    display: none;
}

/* Show the checkbox when checked */
.checkboxContainer input:checked~.checkbox:after {
    display: block;
}

/* Style the checkbox/indicator */
.checkboxContainer .checkbox:after {
    left: 6px;
    top: 2px;
    width: 5px;
    height: 10px;
    border: solid white;
    border-width: 0 2px 2px 0;
    -webkit-transform: rotate(45deg);
    -ms-transform: rotate(45deg);
    transform: rotate(45deg);
}

.systemCheckbox {
    position: absolute;
    opacity: 0;
    cursor: pointer;
    height: 0;
    width: 0;
}

.inputContainer {
    display: flex;
    align-items: center;
    gap: 8px;
    margin: 0 8px;
}

.inputContainer label {
    margin: 0;
}

/*
@media screen and (max-width: 1200px) {
    .filterBoxContent {
        height: 195px;
        overflow-y: auto;
    }
}
*/

@media screen and (max-width: 992px) {
    .filterBoxContent {
        height: 150px;
        overflow-y: auto;
        grid-template-rows: unset;
        grid-auto-flow: unset;
    }

    h6 {
        font-size: 1.1rem !important;
    }
}